import { createEvent, Effect } from 'effector';
import { logOut } from '../JWT/logOut';
import { addressesSign } from '../../addresses/sign';

export function effectListener<Params, Done, Fail = Error>(
  fx: Effect<Params, Done, Fail>,
  timeout: number,
) {
  let timerId: NodeJS.Timeout;
  let skipScheduleCount = 0;

  function event(params: Params) {
    clearTimeout(timerId);

    const pathnameRaw =
      typeof window !== 'undefined' ? window.location.pathname : '';
    const pathname = (() => {
      if (pathnameRaw !== '/' && pathnameRaw.endsWith('/')) {
        return pathnameRaw.slice(0, -1);
      }
      return pathnameRaw;
    })();
    const isPublicSignOrRoot =
      pathname === '/' || pathname === addressesSign.signPath;

    if (isPublicSignOrRoot) {
      skipScheduleCount += 1;
      return;
    }

    timerId = setTimeout(() => {
      if (document.hidden) {
        timerId = setTimeout(() => {
          event(params);
        }, timeout);
        return;
      }
      fx(params);
    }, timeout);
  }

  fx.finally.watch(({ params }) => {
    event(params);
  });

  const abort = createEvent();
  abort.watch(() => {
    clearTimeout(timerId);
  });

  logOut.watch(() => {
    clearTimeout(timerId);
  });
  return { abort, fx };
}
